export const DIRECT_MESSAGE_CHANNEL_TYPES = ['messaging', 'personal'];
export const GROUP_CHANNEL_TYPES = ['group', 'team'];
